import { IconProps } from "./dto";

export function ArrowLeftIcon(props: IconProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6667 8.00065H3.33337M3.33337 8.00065L7.99996 3.33398M3.33337 8.00065L7.99996 12.6673" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}